"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const SearchQuery = (0, graphql_tag_1.default)(`
  query searchQuery(
    $term: String = ""
    $filters: [FilterInput]
    $sortType: String
    $sortOrientation: String
    $page: Int
    $pageSize: Int = 20
    $zipCode: String
    $latitude: Float
    $longitude: Float
    $pmdPromoter: String
    $storeId: String
    $partnerId: String
    $sellerId: String
    $customerId: String
    $showUnavailable: Boolean = true
    $searchExperiment: String
    $alwaysShowSubcategoryFilters: Boolean = true
    $toggleWishlist: Boolean = true
  ) {
    search(
      searchRequest: {
        query: $term
        pagination: { page: $page, size: $pageSize }
        filters: $filters
        sort: { type: $sortType, orientation: $sortOrientation }
        location: { zipCode: $zipCode, latitude: $latitude, longitude: $longitude }
        metadata: {
          partnerId: $partnerId
          sellerId: $sellerId
          showUnavailable: $showUnavailable
          loyaltyParams: { pmdPromoter: $pmdPromoter, storeId: $storeId }
          customerId: $customerId
          searchExperiment: $searchExperiment
          alwaysShowSubcategoryFilters: $alwaysShowSubcategoryFilters
        }
      }
    ) {
      products {
        isOnWishlist @include(if: $toggleWishlist)
        type
      }
      sorts {
        label
        selected
        type
        orientation
      }
      pagination {
        page
        pages
        records
        start
        size
      }
    }
  }
`);
exports.default = SearchQuery;
